<template>
  <modal titulo="Processando Ação" id="processo-notificacao" :loading="resumo.loading" :closeable="!resumo.loading">
    <p>
      <template v-if="resumo.mensagem">
        {{resumo.mensagem}} {{ resumo.contador ? `: ${resumo.atual} / ${resumo.total}`:''}}
      </template>
      <template v-if="resumo.erros.length > 0">
        <div></div>
        <br>
        <div>
          <span style="color:red">Erros encontrados[{{resumo.erros.length}}]</span>
        </div>
        <div v-for="(erro, index) in resumo.erros" :key="index">
          <span style="font-weight: bold;">Erro:</span> {{erro}}
        </div>
      </template>
    </p>
  </modal>

</template>

<script>
import Modal from "@/components/Modal.vue";
import FrontBusiness from "@/business/FrontBusiness";
import NotificacaoBusiness from "@/business/notificacao/NotificacaoBusiness.js";
import RelatorioBusiness from "@/business/RelatorioBusiness";
import LacunaBusiness from "@/business/LacunaBusiness";

export default {
  name: "ModalAcaoLoteNotificacao",
  components: {Modal},
  props:{
    acao: { type: String, default: '' },
    notificacoes: {type: Array, default: () => []},
    forcarDownload:{type:Boolean ,default:false}
  },
  modal: {
    width: 800,
    escapable: false
  },
  data() {
    return {
      resumo : {
        mensagem: false,
        loading : true,
        total : 0,
        atual : 0,
        inicio : this.$moment(),
        fim : null,
        contador:true,
        erros:[]
      },
    }
  },
  mounted() {
    setTimeout(this.load, 100);
  },
  methods:{
    close() {
      FrontBusiness.closeModal();
    },

    async load() {
      this.resumo.total = this.notificacoes.length;
      switch (this.acao) {
        case 'BAIXAR_PDF':
          await this.downloadPDF();
          break;
        case 'BAIXAR_PDF_ASSINADO':
          await this.downloadPDFAssinado();
          break;
        case 'ASSINAR_PDF':
          await this.assinarPdf();
          break;
      }
    },

    nomeNotificacao(notificacao) {
      return `${notificacao.codigo || ''}`;
    },

    async downloadPDF() {
      this.$set(this.resumo, 'contador', true);
      let index = 1;
      let numErros = 0;
      for (const notificacao of this.notificacoes) {
        this.$set(this.resumo, 'mensagem', 'Preparando Arquivos.');
        this.resumo.atual = index++;
        await RelatorioBusiness.downloadPdf(NotificacaoBusiness.baixarNotificacao(notificacao.id), `notificacao-${notificacao.codigo}.pdf`)
          .catch(erro => {
            numErros += 1;
            this.resumo.erros.push(`${this.nomeNotificacao(notificacao)} - ${erro.message || 'Erro ao gerar pdf'}`)
          })
      }
      this.finalizarProcesso(numErros, this.notificacoes.length);
    },

    async downloadPDFAssinado() {
      this.$set(this.resumo, 'contador', true);
      let index = 1;
      let numErros = 0;
      for (const notificacao of this.notificacoes) {
        if (notificacao.assinatura || this.forcarDownload) {
          this.$set(this.resumo, 'mensagem', 'Downloads dos arquivos.');
          this.resumo.atual = index++;
          const pdf = await LacunaBusiness.download('notificacao', notificacao.id)
            .catch(erro => {
              numErros += 1;
              this.resumo.erros.push(`${this.nomeNotificacao(notificacao)} - ${erro.message || 'Erro ao buscar PDF assinado'}`)
            });

          if (pdf) {
            FrontBusiness.downloadFile(pdf, `notificacao-${notificacao.codigo}.pdf`);
          }

        } else {
          numErros += 1;
          this.resumo.erros.push(`${this.nomeNotificacao(notificacao)} - Assinatura não encontrada`)
        }
      }
      this.finalizarProcesso(numErros, this.notificacoes.length);
    },

    async assinarPdf() {
      await LacunaBusiness.preauthorizeSignatures(await LacunaBusiness.getThumb(), this.notificacoes.length).catch(e => {
        FrontBusiness.showError('', 'Erro ao tentar utilizar o certificado digital. Realize seu login novamente.');
        this.close();
      });

      this.$set(this.resumo, 'contador', true);
      let index = 1;
      let numErros = 0;
      for (const notificacao of this.notificacoes) {
        this.$set(this.resumo, 'mensagem', 'Assinando Arquivos.');
        this.resumo.atual = index++;
        await LacunaBusiness.sign('notificacao', notificacao.id, '', `notificacao-${notificacao.codigo}.pdf`).catch(e => {
          numErros += 1;
          this.resumo.erros.push(`${this.nomeNotificacao(notificacao)} - ${e?.message || e}`)
        });
      }
      this.finalizarProcesso(numErros, this.notificacoes.length);
    },

    finalizarProcesso(numErros, numNotificacoes) {
      this.$set(this.resumo, 'contador', false);
      this.resumo.loading = false;
      if (numErros > 0 && numErros === numNotificacoes) {
        this.$set(this.resumo, 'mensagem', `Falha na execução do processo.`);
      } else if (numErros > 0 && numErros < numNotificacoes) {
        this.$set(this.resumo, 'mensagem', 'Concluído parcialmente.');
      }
      if (numErros === 0 && numNotificacoes > 0) {
        this.$set(this.resumo, 'mensagem', 'Concluído.');
        this.close();
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
